import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LabelService} from '../../../shared/services/label.service';
import {AlertService} from '../../../shared/services/alert.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-add-label',
  templateUrl: './add-label.component.html',
  styleUrls: ['./add-label.component.scss']
})
export class AddLabelComponent implements OnInit {
  addLabelForm: FormGroup;
  submitted: any = false;
  submitting: any = false;
  color: any;
  id: any;
  textColors: any = [
    {
      'name': 'Light',
      'value': 'LIGHT'
    },
    {
      'name': 'Dark',
      'value': 'DARK'
    }
  ];

  constructor(private router: Router,
              private fb: FormBuilder,
              private labelService: LabelService,
              private alertService: AlertService,
              private activatedRoute: ActivatedRoute,
              private _location: Location) {
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.refresh();
  }

  refresh() {
    this.addLabelForm = this.fb.group({
      'name': ['', Validators.required],
      'color': [''],
      'text': ['', Validators.required],
    });
    if (this.id) {
      this.detail(this.id);
    }
  }

  back() {
    // this.router.navigateByUrl('labels');
    this._location.back();
  }

  detail(id) {
    this.labelService.detail(parseInt(id)).subscribe(data => {
      if (data) {
        this.color = data.color;
        this.addLabelForm.patchValue({
          'name': (data && data.name) ? data.name : '',
          'text': (data && data.text) ? data.text : ''
        });
      }
    }, error => {
      this.back();
    });
  }

  submit() {
    this.submitted = true;
    if (!this.addLabelForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'name': (this.addLabelForm.value && this.addLabelForm.value.name) ? this.addLabelForm.value.name : '',
        'color': this.color,
        'text': (this.addLabelForm.value && this.addLabelForm.value.text) ? this.addLabelForm.value.text : ''
      };
      this.submitting = true;
      this.labelService.create(params).subscribe(data => {
        if (data) {
          this.submitting = false;
          this.submitted = false;
          this.back();
        }
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
            this.alertService.showErrors(error['error']['errors'].name[0]);
            return;
          }
          if (error['error']['errors'].color && error['error']['errors'].color.length > 0) {
            this.alertService.showErrors(error['error']['errors'].color[0]);
            return;
          }
        }
      });
    }
  }

  update() {
    this.submitted = true;
    if (!this.addLabelForm.valid) {
      return;
    }
    if (this.submitted) {
      const params = {
        'name': (this.addLabelForm.value && this.addLabelForm.value.name) ? this.addLabelForm.value.name : '',
        'color': this.color,
        'text': (this.addLabelForm.value && this.addLabelForm.value.text) ? this.addLabelForm.value.text : ''
      };
      this.submitting = true;
      this.labelService.update(this.id, params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.back();
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
            this.alertService.showErrors(error['error']['errors'].name[0]);
            return;
          }
          if (error['error']['errors'].color && error['error']['errors'].color.length > 0) {
            this.alertService.showErrors(error['error']['errors'].color[0]);
            return;
          }
        }
      });
    }
  }
}
